module.exports = __webpack_public_path__ + "img/airdrop-error.dbee378e.svg";